import request from '@/api/request'
import requestv2 from '@/api/requestv2'

const preparePayment = function (data) {
  return request({
    url: '/users/payments',
    method: 'post',
    data
  })
}

const performPayment = function (data) {
  return request({
    url: '/users/payments',
    method: 'patch',
    data
  })
}

const v2 = {
  preparePayment: function (data) {
    return requestv2({
      url: '/guest/payments',
      method: 'post',
      data
    })
  },
  performPayment: function (data) {
    return requestv2({
      url: '/guest/payments',
      method: 'patch',
      data
    })
  }
}

export default {
  preparePayment,
  performPayment,
  v2
}
